export var GLOBAL_MUTED_ERROR_CODES = [];

//# sourceMappingURL=conviva-blocklist.js.map